export const COLORS = {
  darkBlue: '#0b0a55',
  darkBlueAlternative: '#05044c',
  darkerBlue: '#010035',
  dark: '#000000',
  white: '#FFFFFF',
  lightBlue: '#a0d3ff',
  primary: '#ff0090',
  mainGray: '#c5c5c5',
  lightGray: '#e2e2e2',
  darkGray: '#747474',
  opaque: '#050202c9',
}